// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2Rswjf3OK9VxP08POTmXr3","title":"aKKgJYhUIK9I-ptSJQIgm","fixedHeader":"_14hX9_2bom5t-xNbus8zEo","navText":"_2zWSJiuygvzZKcvWPGKF_1","navIcon":"_1sfG6wFojVxXQM_Mn0ly90"};